export function RouteSkeleton() {
  return (
    <div className="page-shell route-skeleton" aria-busy="true" aria-label="Loading page">
      <div className="skeleton skeleton-kicker" />
      <div className="skeleton skeleton-title" />
      <div className="skeleton skeleton-copy" />
      <div className="skeleton skeleton-panel" />
    </div>
  );
}
